import React, { useMemo } from "react";
import { StatusEnum } from "@whatslly/types/tuvis-messaging/TuvisMessagingEnums";
import { SvgV2 } from "@whatslly/ui-components/v2/BaseElements/SvgV2";

export const MessageAck: React.FC<{ status: string }> = ({ status }) => {
  const renderStatus = useMemo(() => {
    if (status === StatusEnum.Delivered) {
      return <SvgV2 iconName={"message-delivered"} width={16} height={16} />;
    }
    if (status === StatusEnum.Read) {
      return <SvgV2 iconName={"message-read"} width={16} height={16} />;
    }
    if (status === StatusEnum.Sent) {
      return <SvgV2 iconName={"message-sent"} width={16} height={16} />;
    }
    if (status === StatusEnum.Queued) {
      return <SvgV2 iconName={"message-queued"} width={16} height={16} />;
    }
  }, [status]);
  return <>{renderStatus}</>;
};
